<template>
  <div id="app">
    <div
      class="header-wrap fixed z-2000 left-main top-main right-main w-lay-1L"
    >
      <MainNavigation class="" :key="localeKey" />
    </div>
    <div class="main">
      <router-view v-slot="{ Component }">
        <component :is="Component" />
      </router-view>
      <!-- Modal wrapper -->
      <div
        v-if="route.meta.modal"
        class="modal-overlay"
        @click.self="$router.push('/')"
        @keydown.esc="$router.push('/')"
        tabindex="0"
      >
        <component :is="Component" class="modal-content" />
      </div>
    </div>
    <!-- Disclaimer Popup Overlay 
    <DisclaimPopup
      v-if="showDisclaim"
      @agree="handleDisclaimAgree"
      @logout="handleLogout"
    />
    -->
  </div>
</template>

<script setup>
// src/App.vue
import { ref, watch, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import MainNavigation from '@/components/navigation/MainNavigation.vue'
import DisclaimPopup from '@/components/global/extras/DisclaimPopup.vue'
import { usePocketAuthStore } from '@/stores/usePocketAuthStore'

const { locale } = useI18n()
const { t } = useI18n()
const localeKey = ref(locale.value)
const route = useRoute()
const router = useRouter()
const auth = usePocketAuthStore()

// const showDisclaim = computed(() => {
// return auth.user && auth.member && !auth.member.disclaim_ok
// })

// img load fade
onMounted(() => {
  const fadeIn = (img) => {
    if (!img.classList.contains('loaded')) {
      img.classList.add('loaded')
    }
  }

  const observeImages = () => {
    const imgs = document.querySelectorAll('img')
    imgs.forEach((img) => {
      if (img.complete) {
        fadeIn(img)
      } else {
        img.addEventListener('load', () => fadeIn(img), { once: true })
      }
    })
  }

  observeImages()

  const observer = new MutationObserver(observeImages)
  observer.observe(document.body, { childList: true, subtree: true })
})

// Watch for locale changes and update key for MainNavigation
watch(locale, (newLocale) => {
  localeKey.value = newLocale
})

//
const handleDisclaimAgree = async () => {
  try {
    await auth.updateMember({ ...auth.member, disclaim_ok: true })
    await auth.fetchCurrentMember()
  } catch (err) {
    console.error('Failed to agree to disclaimer:', err)
  }
}

const handleLogout = async () => {
  await auth.logout()
  router.push('/')
}
</script>
